export const defaultRegiondCode = 'ap-northeast-2';

export interface CloudPrice {
    planType: 'free' | 'basic' | 'pro' | 'adv' | 'ent' | undefined;
    price: number;
    billingText?: string;
}
export const cloudPriceTable: CloudPrice[] = [
    {
        planType: 'free',
        price: 0,
    },
    {
        planType: 'basic',
        price: 0,
    },
    {
        planType: 'pro',
        price: 20,
        billingText: 'per workspace/month',
    },
    {
        planType: 'adv',
        price: 40,
        billingText: 'per user/month',
    },
    {
        planType: 'ent',
        price: 40,
        billingText: 'per user/month',
    },
];

export const EMAIL_VALIDATION = {
    TIMER_DURATION: 180, // 3분
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;

export enum EmailStep {
    Send = 'send',
    Check = 'check',
    Confirm = 'confirm',
    Resend = 'resend',
}

export enum EmailError {
    Expired = 'The verification code has expired. Please request a new code.',
    Mismatched = 'The verification code does not match. Please check and try again.',
    Unknown = 'An unknown error occurred. Please try again later.',
}
